export default __webpack_public_path__ + "images/Y6.aa7672e.png";